import isotope from 'vueisotope';
import imagesLoaded from 'vue-images-loaded';
import VueResource from 'vue-resource';
import VeeValidate from 'vee-validate';
import { graphicsData } from '../graphicstool/graphics-data';

const { Vue } = window;
Vue.use(VueResource);
Vue.use(VeeValidate);
window.freeGraphicsTool = new Vue({
  el: '#free-graphics-tool',
  http: {
    headers: {
      'Content-Type': 'application/json'
    }
  },
  directives: {
    imagesLoaded
  },
  components: {
    isotope
  },
  data: {
    layouts: ['masonry', 'vertical'],
    activeList: graphicsData.slice(0, 10),
    masterList: graphicsData,
    currentLayout: 'masonry',
    emailFormData: {
      'List ID': 'af59885b4e',
      EMAIL: ''
    },
    showEmailSuccess: false,
    activePanel: 'home',
    showFaqSection: false,
    filterOption: 'Choose a Category',
    openImageDetail: false,
    openedImageSrc: '',
    showNoResultsMsg: false,
    initialCount: 10,
    loadMoreIncrement: 10,
    imagesLoaded: false,
    showLoadMore: true,
    filterList: [
      'Choose a Category',
      'Fall',
      'Valentines',
      'Summer',
      'Holidays',
      'Spring'
    ],
    option: {
      isJQueryFiltering: false,
      itemSelector: '.element-item',
      stagger: 0,
      percentPosition: true
    }
  },
  watch: {
    // Check the filter category and choose the appropriate path
    filterOption() {
      if (this.filterOption === 'Choose a Category') {
        this.resetGrid();
      } else {
        this.filter(this.filterOption);
      }
    }
  },
  created() {
    this.deviceCheck();
    window.addEventListener('resize', this.deviceCheck, false);
  },
  methods: {
    // Custom filter logic, essentially does what Isotope filtering does
    customfilter(data, key) {
      return data.filter(el => el.category === key.toLowerCase());
    },
    // Filtering logic on masterList
    filter(key) {
      this.resetMasterList();
      this.resetActiveList();
      this.masterList = this.customfilter(this.masterList, key);
      this.activeList = [...this.masterList.slice(0, this.initialCount)];
      this.showLoadMoreCheck();
    },
    // Show the detail image view and block the body from scrolling
    toggleImageDetailView(newSrc) {
      this.openImageDetail = !this.openImageDetail;
      this.openedImageSrc = newSrc;
      document.body.classList.toggle('no-scroll');
    },
    // imagesLoading callback
    imagesLoading() {
      return {
        done: () => {
          this.imagesLoaded = true;
          this.$refs.cpt.layout(this.currentLayout);
        }
      };
    },
    // Used for FAQ and about panels
    toggleFaq() {
      const faqToggleEl = document.getElementsByClassName('faq-arrow')[0];
      this.showFaqSection = !this.showFaqSection;
      if (this.showFaqSection) {
        faqToggleEl.style.transform = 'rotate(180deg)';
      } else {
        faqToggleEl.style.transform = 'rotate(0deg)';
      }
    },
    // The inital load of images
    initialLoad() {
      this.resetActiveList();
      this.activeList = [...this.masterList.slice(0, this.initialCount)];
      this.showLoadMoreCheck();
    },
    // Load more items based on increment value
    loadMore() {
      const loadMoreTotal = this.activeList.length + this.loadMoreIncrement;
      this.activeList = [...this.masterList.slice(0, loadMoreTotal)];
      this.showLoadMoreCheck();
    },
    // Check if load more button should be shown
    showLoadMoreCheck() {
      this.showLoadMore = this.activeList.length !== this.masterList.length;
    },
    // Reset Images and trigger the initial load
    resetGrid() {
      this.resetMasterList();
      this.resetActiveList();
      this.initialLoad();
    },
    // Clear Visible Images
    resetActiveList() {
      this.activeList.length = 0;
    },
    // Clear Master List Images
    resetMasterList() {
      this.masterList = graphicsData;
    },
    // Check device width and set layout accordingly
    deviceCheck() {
      if (window.matchMedia('(max-width: 600px)').matches) {
        this.currentLayout = 'vertical';
      } else {
        this.currentLayout = 'masonry';
      }
    },
    // Validate email with Vee-Validate
    emailValidate() {
      this.$validator.validateAll().then(this.emailSubscribe.bind(this));
    },
    // Subscribe to email list
    emailSubscribe(result) {
      // Bail out if there's an error - shoutout Chris Ruzin for this subscribe setup
      if (!result) {
        return;
      }
      this.$http
        .post(
          'https://mrkt-api-mailchimp.appspot.com/api/mailchimp/blog',
          this.emailFormData
        )
        .then(() => {
          this.showEmailSuccess = true;
        }, () => { });
    }
  }
});
